import { DO_LOGOUT } from '../Login/actions';
import { PUT_TZ } from './actions'

const initialState = {
    tz: []
}

const reducer = (state = initialState, { type, payload }) => {
    switch(type) {

        case PUT_TZ:
            return {
                tz: payload.tz
            }

            case DO_LOGOUT:
                return initialState;
    }
    return state
}

export default reducer